import React from 'react';
import Header from './components/header';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import { API_URL } from './config'

function ForgotPasswordPage() {
    return (
        <> 
            <Header />
            <ForgotPasswordForm />
        </>
    );
  }
  
  export default ForgotPasswordPage; 